// extracted by mini-css-extract-plugin
export var active = "_3m-7";
export var container = "_3m-0";
export var evenWidth = "_3m-4";
export var large = "_3m-5";
export var outlet = "_3m-8";
export var slide = "_3m-2";
export var small = "_3m-6";
export var tab = "_3m-3";
export var tabs = "_3m-1";